import {
  BuildingEffects,
  DraftRate,
  RankModifiers,
  Ranks,
  Ritual,
  Title,
} from '../@types/Calculations';

export const BASE_THIEF_COST = 500;
export const BASE_SPEC_COST = 350;
export const BASE_ELITE_COST = 1200;
export const BARREN_HOUSING = 15;
export const BUILT_HOUSING = 25;
export const BANKS_GC_RAW = 25;
export const SPEC_WAGE = 0.5;
export const ELITE_WAGE = 0.75;
export const DEFAULT_SPEC_VALUE = 10;
export const DEFAULT_SOLD_DEF_VALUE = 3;
export const DEFAULT_SOLD_OFF_VALUE = 3;
export const DEFAULT_HORSE_VALUE = 2;
export const DEFAULT_ELITE_VALUE = 10;
export const DEFAULT_PRISONER_VALUE = 10;
export const HOME_BONUS = 10;
export const FARMS_BUSHEL = 60;
export const BARREN_BUSHEL = 2;
export const TOWER_RUNE = 12;
export const PRISONER_GC = 0.75;
export const EMPLOYED_GC = 3;
export const UNEMPLOYED_GC = 1;
export const PRISONERS_JOB = 2;

// Spell mods
export const PAT_DRAFT_MOD = 1.3;
export const GREED_WAGE_MOD = 1.25;
export const FL_FOOD_MOD = 1.25;
export const HI_WAGE_MOD = 0.7;
export const IA_WAGE_MOD = 0.85;
export const FAN_OME_MOD = 1.05;
export const FAN_DME_MOD = 0.95;
export const BL_OME_MOD = 1.1;
export const MP_DME_MOD = 1.05;
export const GP_DME_MOD = 1.1;

export const DEFAULT_MOD = 1.0;

export const buildingEffects: BuildingEffects = {
  MILL_BUILDING_COST: { scale: 1.0, limit: 1.0, be: true },
  MILL_EXPLORATION_COST_GOLD: { scale: 0.75, limit: 0.75, be: true },
  MILL_EXPLORATION_COST_MEN: { scale: 0.5, limit: 0.5, be: true },
  BANK_INCOME_LEVEL: { scale: 0.375, limit: 0.375, be: true },
  TRAINING_GROUND_OFFENSIVE_EFFICIENCY: {
    scale: 0.375,
    limit: 0.375,
    be: true,
  },
  BARRACKS_REDUCED_MERCENARY_COST: { scale: 0.5, limit: 0.5, be: true },
  ARMOURY_MILITARY_TRAINING_COST: { scale: 0.375, limit: 0.375, be: true },
  ARMOURY_MILITARY_WAGES_AND_DRAFT_COST: {
    scale: 0.5,
    limit: 0.5,
    be: true,
  },
  BARRACKS_ATTACK_TIME: { scale: 0.375, limit: 0.375, be: true },
  FORT_DEFENSIVE_EFFICIENCY: { scale: 0.375, limit: 0.375, be: true },
  CASTLE_PROTECT_RESOURCE_UNDER_ATTACK: {
    scale: 0.5,
    limit: 0.5,
    be: true,
  },
  HOSPITAL_CURE_PLAGUE_CHANCE: { scale: 0.5, limit: 0.75, be: true },
  HOSPITAL_MILITARY_LOSS: { scale: 0.75, limit: 0.75, be: true },
  THIEVES_DEN_THIEVERY_ESCAPE_CAPTURE_FRACTION: {
    scale: 0.95,
    limit: 1.0,
    be: true,
  },
  THIEVES_DEN_THIEVERY_EFFECTIVENESS: {
    scale: 0.75,
    limit: 0.75,
    be: true,
  },
  WATCHTOWER_THIEVERY_PREVENTION_PROBABILITY: {
    scale: 0.375,
    limit: 0.375,
    be: true,
  },
  WATCHTOWER_THIEVERY_DAMAGE_REDUCTION_FRACTION: {
    scale: 0.625,
    limit: 0.625,
    be: true,
  },
  TRAINING_GROUND_MILITARY_TRAINING_COST: {
    scale: 0.375,
    limit: 0.375,
    be: true,
  },
  TRAINING_GROUND_MILITARY_WAGES_AND_DRAFT_COST: {
    scale: 0.5,
    limit: 0.5,
    be: true,
  },
  HOSPITAL_BIRTH_RATE: { scale: 0.5, limit: 0.5, be: true },
  TRAINING_GROUND_OFFENSIVE_MILITARY_CASUALTIES: {
    scale: 0.125,
    limit: 0.125,
    be: true,
  },
};

const rituals: Ritual[] = [
  {
    key: 0,
    name: 'None',
    incomeModifier: 1,
    constructionModifier: 1,
    omeModifier: 1,
    dmeModifier: 1,
    wagesModifier: 1,
    trainingCostModifer: 1,
    draftModifier: 1,
    beModifier: 1,
    constructionTimeModifier: 1,
    trainingTimeModifer: 1,
  },
  {
    key: 1,
    name: 'Affluent',
    incomeModifier: 1.15,
    constructionModifier: 1,
    omeModifier: 1,
    dmeModifier: 1,
    wagesModifier: 1,
    trainingCostModifer: 1,
    draftModifier: 1.2,
    beModifier: 1,
    constructionTimeModifier: 1,
    trainingTimeModifer: 1,
  },
  {
    key: 2,
    name: 'Expedient',
    incomeModifier: 1,
    constructionModifier: 1,
    omeModifier: 1,
    dmeModifier: 1,
    wagesModifier: 1,
    trainingCostModifer: 1,
    draftModifier: 1.2,
    beModifier: 1.1,
    constructionTimeModifier: 1,
    trainingTimeModifer: 1,
  },
  // {
  //   key: 3,
  //   name: "Expropriation",
  //   incomeModifier: 1,
  //   constructionModifier: 1,
  //   omeModifier: 1,
  //   dmeModifier: 1,
  //   wagesModifier: 1,
  //   trainingCostModifer: 1,
  // },
  {
    key: 4,
    name: 'Godspeed',
    incomeModifier: 1,
    constructionModifier: 1,
    omeModifier: 1,
    dmeModifier: 1,
    wagesModifier: 1,
    trainingCostModifer: 1,
    draftModifier: 1,
    beModifier: 1,
    constructionTimeModifier: 1,
    trainingTimeModifer: 1,
  },
  {
    key: 5,
    name: 'Havoc',
    incomeModifier: 1,
    constructionModifier: 1,
    omeModifier: 1,
    dmeModifier: 1,
    wagesModifier: 1,
    trainingCostModifer: 1,
    draftModifier: 1,
    beModifier: 1,
    constructionTimeModifier: 1,
    trainingTimeModifer: 1,
  },
  {
    key: 6,
    name: 'Onslaught',
    incomeModifier: 1,
    constructionModifier: 1,
    omeModifier: 1.1,
    dmeModifier: 1,
    wagesModifier: 1,
    trainingCostModifer: 1,
    draftModifier: 1,
    beModifier: 1,
    constructionTimeModifier: 1,
    trainingTimeModifer: 1,
  },
  {
    key: 7,
    name: 'Stalwart',
    incomeModifier: 1,
    constructionModifier: 1,
    omeModifier: 1,
    dmeModifier: 1.05,
    wagesModifier: 1,
    trainingCostModifer: 1,
    draftModifier: 1,
    beModifier: 1,
    constructionTimeModifier: 1,
    trainingTimeModifer: 1,
  },
  {
    key: 8,
    name: 'Haste',
    incomeModifier: 1,
    constructionModifier: 1,
    omeModifier: 1,
    dmeModifier: 1,
    wagesModifier: 1,
    trainingCostModifer: 1,
    draftModifier: 1,
    beModifier: 1,
    constructionTimeModifier: 0.75,
    trainingTimeModifer: 0.75,
  },
];

export const getRankLevel = (title: Title): number => {
  return ranks[title];
};

export const ranks: Ranks = {
  Peasant: 0,
  King: 2,
  Queen: 2,
  Knight: 1,
  Lady: 1,
  Lord: 2,
  'Noble Lady': 2,
  Baron: 3,
  Baroness: 3,
  Viscount: 4,
  Viscountess: 4,
  Count: 5,
  Countess: 5,
  Marquis: 6,
  Marchioness: 6,
  Duke: 7,
  Duchess: 7,
  Prince: 8,
  Princess: 8,
};

export const rankModifiers: RankModifiers = {
  population: 0.01,
  me: 0.01,
  income: 0.02,
  food: 0.02,
  runes: 0.02,
  wpa: 0.03,
  tpa: 0.03,
};

const draftRates: DraftRate[] = [
  { key: 0, name: 'None', speed: 0, cost: 0 },
  { key: 1, name: 'Reservist', speed: 0.3, cost: 30 },
  { key: 2, name: 'Normal', speed: 0.6, cost: 50 },
  { key: 3, name: 'Aggressive', speed: 1, cost: 75 },
  { key: 4, name: 'Emergency', speed: 1.5, cost: 110 },
];

export { rituals, draftRates };
